export default {"src":"/_next/static/media/gavel_24.dd46e608.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};